<template>
  <v-sheet height="100%">
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <v-container v-if="!loading" class="pt-6 pb-6 pb-md-10 pt-md-12">
        <v-row justify="center">
          <v-col cols="12" md="10">
            <div class="font-weight-bold text-h5 text-sm-h4">
              {{ video.title }}
            </div>
            <div class="d-flex justify-end pt-5">
              <ShareLinksWidget />
            </div>
            <iframe
              class="d-block mt-6 mt-md-8 item-video black"
              :src="video.videoEmbedURL"
              :title="video.title"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>

            <div
              v-if="video.text"
              class="mt-6 mt-md-8 ck-content item-text"
              v-html="video.text"
            ></div>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import ShareLinksWidget from "../components/widgets/ShareLinksWidget.vue";
import { getYoutubeCode } from "../utils/getYoutubeCode";

const _config = {
  mod: "videos",
};
export default {
  data: () => ({
    loading: true,
    video: {},
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    getVideo() {
      const params = {
        id: this.itemId,
      };
      this.$rest(_config.mod)
        .get(params)
        .then((data) => {
          this.video = {
            title: data.title,
            text: data.text,
            videoEmbedURL: `https://www.youtube.com/embed/${getYoutubeCode(
              data.video
            )}?autoplay=1`,
          };
        })
        .catch(() => this.$router.replace("/error404"))
        .finally(() => (this.loading = false));
    },
  },
  created() {
    this.getVideo();
  },
  watch: {
    itemId() {
      this.getVideo();
    },
  },
  components: { LoadingWidget, ShareLinksWidget },
};
</script>

<style lang="scss" scoped>
.item-video {
  width: 100%;
  object-fit: cover;
  aspect-ratio: 16/9;
}
</style>
